import Vue from 'vue'
import Firebase from './firebase.js'
import store from './store.js'


var thePoster = undefined
function poster() {
  if (!thePoster) {
    thePoster = new Vue({
      name: 'ActionLogPoster',
      store,
      data: {
        ref: undefined,
        refTag: undefined
      },
      computed: {
        uid: function() {
          console.log('store',this.$store)
          if (this.$store.state.user)
            return this.$store.state.user.uid
          return undefined
        },
      },
      methods: {        
        post: function(action, details) {
          var entry = { uid: this.$store.state.user.uid,
                        action: action,
                        details: details,
                        progress: 0,
                        timestamp: {'.sv' : 'timestamp' } }
          var now = new Date()
          var tag = now.getUTCFullYear()+'-'+(now.getUTCMonth()+1)+'-'+now.getUTCDate()
          //console.log('ACTIONLOG:',tag,entry)
          if (!this.ref || !this.refTag || this.refTag != tag) {
            this.ref =  Firebase.database.ref('/actionlog/'+tag)
            this.refTag = tag
          }
          this.$nextTick( () => this.ref.push().set(entry) )
        }
      },
    })
  }
  return thePoster
}

function postAction(action, details) {
  try {
    poster().post(action, details)
  } catch (error) {
    console.error('ActionLog',error)
  }
}

export default postAction



// WEBPACK FOOTER //
// ./src/actionlog.js